<!--
  Bloomreach banner is intentionally placed in the root page layout instead of the dedicated promo page.
  This is a temporary workaround because the bloomreach promo layout
  is not compatible with our promo page structure (which includes default paddings and footer).
  Moving it to root level ensures proper banner display without layout conflicts.
-->

<global-bloomreach-banner-container id="rewards-hub"/>
<router-outlet />
